module.exports = __webpack_public_path__ + "img/9791195058143.266f015c.jpg";